import React, { Fragment, useState, useRef, useEffect } from 'react'
import Header from '../Header';
import Footer from '../Footer';

import Slider from 'react-slick';
import DomineChoosing from './DomineChoosing.jsx'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../slider.css';
import { Link } from 'react-router-dom';
const DomineRegistration = () => {
    useEffect(() => {
        document.title = 'Domine Registration Services | KumbhaaTech Solutions';
        return () => {
            document.title = 'leading software company - KumbhaaTech Solutions';
        };
    }, []);

    const [activeIndex, setActiveIndex] = useState(0);

    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true, // Enable auto slide
        autoplaySpeed: 3000, // 3 seconds per slide
        beforeChange: (current, next) => {
            setActiveIndex(next);
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const cards = [
        {
            image: "assets/images/icons/CMS.svg",
            heading: "Brand Identity",
            description: "A custom domain name helps build brand identity and credibility, distinguishing your website from competitors and strengthening brand recognition.",

        },
        {
            image: "assets/images/icons/online.png",
            heading: "Online Presence",
            description: "Domain registration establishes your online presence, making your website accessible to users worldwide and expanding your reach.",

        },
        {
            image: "assets/images/icons/Enterprise Resource Planning.svg",
            heading: "Professionalism ",
            description: "A custom domain name adds a professional touch to your online presence, enhancing your reputation and trustworthiness in the eyes of visitors.",

        },
        {
            image: "assets/images/icons/seo.svg",
            heading: "Search Engine Visibility",
            description: "A relevant and keyword-rich domain name can improve your website's search engine visibility, making it easier for users to find and discover your site online.",

        }
    ];

    const handlePrevious = () => {
        sliderRef.current.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current.slickNext();
    };


    return (
        <Fragment>
            <Header />

            <div className="custom-banner-1">
                <div className="container">
                    <div className="custom-banner-content">
                        <div className="left-content">
                            <h1>
                                <span className='g-c-b'>Domain Registration</span> Services at the Best Price
                            </h1>
                        </div>
                        <div className="right-content">
                            <hr
                                className="orange-line"
                                style={{ height: '5px', width: '50px', background: '#00a798', opacity: '1' }}
                            />

                            <p>Secure your online identity with Kumbhaatech Solutions. We offer reliable and affordable domain registration services to help you establish a strong online presence. Find your perfect domain name today.</p>

                            <Link className="text-white" to="/kumbhatech-affordable-website-design-chennai">
                                Register Your Domain Now! <i className="fa fa-angle-right abt-btn" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className='breadcrumb'>
                <div className='container'>
                    <div class="">
                        <Link href="/">Home</Link>
                        <Link href="/services">Services</Link>
                        <span>Domine Registration</span>
                    </div>
                </div></div>
            <section className="web-development-container">
                <div class="position-relative">

                    <div class="animation-home-about-green  animation-round-bg top-right"></div>
                    <div class="animation-home-about-green animation-round-bg bottom-left"></div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className=" col-lg-8 web-2-hide">
                            <div className="image-container-web ">
                                <img src="assets/images/New folder/blog_1.webp" alt="domine registrations" loading='lazy' decoding='async' />
                                {/* <a href="https://www.freepik.com/free-photo/html-css-collage-concept-with-person_36295457.htm#fromView=search&page=1&position=10&uuid=45d7d1b2-7ddd-44e7-b0fb-5f55ac5a4d67">Image by freepik</a> */}
                            </div>
                        </div>
                        <div className="web-heading col-md-8">
                            <h2>Unveiling the <span className='o-c-b-w-b '>Importance of Domain</span> Registration: How KumbhaaTech Provides Affordable Solutions.</h2>
                        </div>
                    </div>
                    <div className="row  w-container" >
                        <div className="col-lg-5 web-1-hide">
                            <div className="image-container-web">
                                <img src="assets/images/New folder/blog_1.webp" alt="domine registrations" loading='lazy' decoding='async' />
                                {/* <a href="https://www.freepik.com/free-photo/html-css-collage-concept-with-person_36295457.htm#fromView=search&page=1&position=10&uuid=45d7d1b2-7ddd-44e7-b0fb-5f55ac5a4d67">Image by freepik</a> */}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-10">
                            <div className="web-content">
                                <p className='p-20'>In the digital landscape, your domain name is your online identity. It's the gateway through which users access your website, and it plays a crucial role in shaping your brand's online presence.</p>
                                <p>At KumbhaaTech, we understand the significance of securing the right domain name for your business. That's why we provide cheap domain registration services, ensuring that businesses of all sizes can establish their online presence without breaking the bank.</p>
                                <Link to='/kumbhatech-affordable-website-design-chennai' className='text-black'>Know More <i className="fa fa-angle-right abt-btn-b" aria-hidden="true"></i></Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="info-section" >
                <div class="position-relative">

                    <div class="animation-home-about-green animation-round-bg top-right-web"></div>

                </div>
                <div className="container">
                    <div className="row" >
                        <div className="col-lg-12">
                            <div className="row section-heading">
                                <div className="col-md-8 col-lg-6">
                                    <h2 className="text-white">Importance of Cheap <span className="gglr"> Domain Registration</span></h2>
                                </div>
                                <div className="col-lg-6 col-md-10">
                                    <p className=' section-description '>In today’s competitive market, businesses must prioritize cost-effective solutions without compromising quality. Cheap domain registration services offer the following advantages:</p>
                                </div>
                            </div>
                            <div className='info-card-container'>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/affortablity.svg" alt="Affordability" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Affordability </h3>
                                        <p>Affordable domain registration helps businesses of all sizes establish an online presence without high costs, allowing resources to be invested in growth areas like marketing. It enables multiple or premium domain acquisitions, fostering a competitive, accessible digital marketplace.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/costMarekting-g.svg" alt="Business Websites" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Scalability</h3>
                                        <p>Scalable domain registration supports business growth by easily adding new domains as needed. It allows efficient management of large portfolios with flexible pricing, ensuring businesses maintain a strong, consistent brand identity across markets.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/Brand-g.svg" alt="Brand " loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Brand Protection</h3>
                                        <p>Brand protection through domain registration ensures that companies control their online identity, preventing malicious actors from exploiting their brand. It helps maintain customer trust and safeguards against cybersquatting.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/automation-g.svg" alt="Competitive Edge" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Competitive Edge </h3>
                                        <p>Strategic domain selection offers a competitive advantage, improving visibility and positioning. It helps businesses stay ahead by securing premium or niche domains, boosting SEO, and capturing market share before competitors.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section class="home-about-section " id='understanding'>

                <div class="container">
                    <div className="row">
                        <div class="home-about-container  " >
                            <div className='col-lg-5'>
                                <div className='second-about-mask-image '>
                                    <img src="assets/images/New folder/scaliblity.webp" alt="Understanding  Domain registrationt" loading='lazy' decoding='async' />
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-10 '>
                                <div className='home-about-container-inside '>
                                    <div className=' web-heading '>
                                        <h2> Kumbhatech Solutions:<span className='o-c-b-w-b'>Your Partner in Affordable</span> Domain registrationt</h2>

                                    </div>
                                    <p className='p_20'>Secure your online identity with ease and confidence. At Kumbhatech Solutions, we provide affordable and reliable domain registration services tailored to meet the unique needs of your business. Start your journey to a strong online presence today.</p>
                                    <br />
                                    <p>Domain registration is the process of acquiring a unique web address for your website, allowing users to find and access your site on the internet. It involves choosing a domain name, checking its availability, and registering it through a domain registrar.</p>

                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>

            <section className='does-work'>
                <div className="container">
                    <div className="col-lg-7 web-heading-green ">
                        <h2 className='text-white'>Why a <span className='gglr'>Domain Name</span> is Essential for Building Your Online Presence</h2>
                    </div>


                    <div className="overflow-hidden does_wrapper">

                        <div className='position-relative'>
                            <div className="scroll-container">
                                <div className='how_does_heading'>
                                    KUMBHA
                                </div>
                                <div className="how_container">
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>01</span>
                                            <h3>Establishing Online Identity</h3>
                                            <p>A domain name serves as your unique online identity, representing your brand, business, or personal website on the internet.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>02</span>
                                            <h3>Business Websites</h3>
                                            <p>Businesses register domain names to establish their online presence, showcase products or services, and attract customers.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>03</span>
                                            <h3>Enhancing Brand Recognition</h3>
                                            <p>A memorable and relevant domain name helps users remember and recognize your brand, increasing brand visibility and recall.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>04</span>
                                            <h3>Personal Website</h3>
                                            <p>Individuals register domain names for personal blogs, portfolios, or online resumes, creating a unique online identity.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>05</span>
                                            <h3>Creating Credibility</h3>
                                            <p>A custom domain name adds credibility and professionalism to your online presence, instilling trust in visitors and potential customers.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>06</span>
                                            <h3>E-commerce Platforms</h3>
                                            <p>E-commerce websites register domain names to sell products or services online, attracting customers and driving sales.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>07</span>
                                            <h3>Enabling Website Accessibility</h3>
                                            <p>Domain registration ensures that your website is accessible to users worldwide, allowing them to find and access your site via the internet.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>08</span>
                                            <h3>Branding and Marketing</h3>
                                            <p>Domain registration supports branding and marketing efforts by providing a memorable and relevant web address for promotional campaigns.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='benefit-slider-section' id='benefits'>
                <div className="container">
                    <div className='row b-heading-container content-w'>
                        <div className="col-lg-7 col-md-9">
                            <div className="benefit-heading">
                                <h2>Benefits of <span className='o-c-b-w-b '>Domain Registration</span></h2>

                            </div>
                        </div>
                        <div className='col-md-3 col-lg-5 green'>
                            <div className="bottom-container">
                                <div className="custom-arrows">
                                    <button className="custom-arrow" onClick={handlePrevious}>
                                        &#8249;
                                    </button>
                                    <button className="custom-arrow" onClick={handleNext}>
                                        &#8250;
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="slider-container digital">
                                <Slider ref={sliderRef} {...settings}>
                                    {cards.map((card, index) => (
                                        <div className={`slider-card ${index === activeIndex ? 'active' : ''}`} key={index}>
                                            <div className="slider-image">
                                                <img
                                                    src={card.image}
                                                    alt={card.heading}

                                                    loading='lazy'
                                                    decoding='async'
                                                />
                                            </div>
                                            <h4 className="h-hide">{card.heading}</h4>
                                            <div className={`c-conetnt ${index === activeIndex ? 'show' : ''}`}>
                                                <h4 className="card-heading">{card.heading}</h4>
                                                <p className="card-description">
                                                    {card.description}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>


                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="apply-now" id="approch" style={{ background: 'white' }}>
                <div className='apply-image-container'>
                    <div className="container">
                        <div className="row ac-space" >
                            <div className='col-lg-6 col-md-10 '>
                                <h2 className='ap-accordion-heading'><span className='o-c-b-w-b '>KumbhaTech’s </span>Approach to Cheap Domain Registration </h2>

                            </div>
                            <div className="col-lg-5 col-md-9">
                                <p className='ap-accordion-description'>At KumbhaaTech, we understand the importance of cost-effective solutions that deliver results. Our approach to domain registration focuses on:</p>
                            </div>
                        </div>
                        <div className="row l-t" >

                            <DomineChoosing />
                            <div className="col-lg-6 p-i-3">
                                <img src="assets/images/how-we-work-04.webp" alt="KumbhaTech’s Approach " loading='lazy' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className='fixed-bacground-section'>
                <div className="fixed-background-5">
                    <div className="fixed-background-content">
                        <div className="fixed-background-content-inside">
                            <h2>Ready to Secure Your Online Identity?</h2>
                            <p>Ensure your online presence starts with the right domain name. Contact Kumbhatech Solutions for domain registration services. We provide a seamless process to help you secure your desired domain quickly and affordably. Let us assist you in establishing a strong online identity that aligns with your business goals!.</p>
                            <br />
                            <Link to='/kumbhatech-affordable-website-design-chennai' className='benift-btn'>Connect With Us</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="conclusion" id='Conclusion'>
                <div className="container">
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h2 className='conclusion-heading'>conclusion</h2>
                        </div>
                        <div className="col-lg-6">
                            <div className="fist-conclusion-content">
                                <p>In conclusion, domain registration is a fundamental step in establishing your online presence and building brand identity on the internet. A custom domain name not only enhances credibility and professionalism but also plays a crucial role in brand recognition and search engine visibility. Cheap domain registration services offer businesses a cost-effective solution to securing their online identity, ensuring accessibility and affordability without compromising on quality. Contact KumbhaaTech today to learn more about our cheap domain registration services and take the first step towards establishing your online presence.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="second-conclusion-content">
                                <p>By choosing KumbhaaTech, you're partnering with a trusted domain registrar that prioritizes affordability, security, and customer satisfaction. Let us help you secure the perfect domain name for your business at a price that fits your budget.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='news-letter'>
                <div className="news-letter-container">

                    <div className="container">
                        <div className="row">

                            <div className="col-lg-6">
                                <div>
                                    <h4>Get Your Domain Today!</h4>
                                    <p>Ready to claim your online presence? Contact us now to register your domain with ease. Let Kumbhatech Solutions be your trusted partner in building a strong online foundation for your business!.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className='subscribe-btnbox'>
                                    <Link to='/kumbhatech-affordable-website-design-chennai'>Connect With Us <span>+</span></Link></div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </Fragment>
    )
}

export default DomineRegistration;
/* <a href="https://www.freepik.com/free-photo/corporate-management-strategy-solution-branding-concept_28096443.htm#fromView=search&page=1&position=0&uuid=ff2715e4-6f8d-4035-9ed7-c0aeecfb5dd2">Image by rawpixel.com on Freepik</a>online */
/* <a href="https://www.freepik.com/free-photo/young-woman-working-laptop-isolated-white-background_8907406.htm#fromView=search&page=1&position=19&uuid=60ca384b-cb1a-41d2-af00-7881005c1521">Image by diana.grytsku on Freepik</a> profess */